import script from "./vmsCustomAttributeGroupEdit.vue?vue&type=script&lang=js"
export * from "./vmsCustomAttributeGroupEdit.vue?vue&type=script&lang=js"

import "./vmsCustomAttributeGroupEdit.vue?vue&type=style&index=0&id=4a7d1414&lang=css"
import "./vmsCustomAttributeGroupEdit.vue?vue&type=style&index=1&id=4a7d1414&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a7d1414"]])

export default __exports__